// The mailing list: the "Email me when it's released" sign-up (NotifyMeButton), and the pages its emails link to.
export const news = {
    // The sign-up form's consent wording, by version: change NEWS_CONSENT_VERSION (src/api/NewsApi.ts) with any change
    // to what someone agrees to here, so we know which wording each sign-up saw.
    button: 'Email me when {product} is released',
    dialog: {
        title: 'Get an email when {product} is released',
        intro: "We'll email you when {product} is released. Nothing else, unless you ask for it below.",
        signedInIntro: "We'll email {email} when {product} is released. Nothing else, unless you ask for it below.",
        email: 'Email address',
        news: 'Also send me occasional news about Tristar Advanced Software products',
        privacy: 'You can unsubscribe at any time with the link in every email. See our <link>privacy policy</link>.',
        submit: 'Sign me up',
        cancel: 'Cancel',
        close: 'Close',
        checkEmail: 'Almost done: we sent a confirmation link to {email}. Open it within 7 days to finish signing up.',
        signedUp: "You're on the list. We'll email {email} when {product} is released.",
        tooMany: "You've signed up a lot today. Please try again tomorrow.",
        unavailable: "Signing up isn't available right now. Please try again later.",
        problems: {
            email: 'Enter your email address.'
        }
    },
    // /news/confirm?token=…: the link in the confirmation email.
    confirm: {
        title: 'Confirm your sign-up',
        done: "You're on the list. We'll email you when {products} is released.",
        doneWithNews: "You're on the list. We'll email you when {products} is released, and send you occasional news.",
        expired: 'This link has expired or is not valid. Sign up again from the product page to get a new one.',
        noToken: 'This page needs the link from your confirmation email.',
        products: 'See our products'
    },
    // /news/unsubscribe?id=…&token=…: the link at the foot of every list email.
    unsubscribe: {
        title: 'Unsubscribe',
        intro: '{email} gets our emails about:',
        release: 'When {product} is released',
        news: 'Occasional news about Tristar Advanced Software products',
        all: 'Unsubscribe from everything',
        newsOnly: 'Stop the news only',
        done: "You're unsubscribed. We won't email {email} again.",
        doneNews: "Done: we won't send {email} any more news. We'll still email you when the product you asked about is released.",
        gone: "This link is no longer valid: you may have unsubscribed already. If you're still getting our emails, open a <link>support ticket</link>.",
        noToken: 'This page needs the unsubscribe link from one of our emails.'
    }
};

export type NewsMessages = typeof news;
